export function formatFriendCode(code: string) {
  if (code.length !== 12) return `SW-${code.substr(0, 12)}`;

  return `SW-${code.substring(0, 4)}-${code.substring(4, 8)}-${code.substring(
    8,
  )}`;
}
